import { FormPrevious } from 'grommet-icons';
import styled from 'styled-components';

const FormPreviousStyled = styled(FormPrevious)`
  position: relative;
  path {
    position: relative;
    transform: translateX(-0.375rem);
  }
`;

export default FormPreviousStyled;
